<template>
    <AppLayout v-bind="appSharedData.getAppSidebarLayoutProps(pageMeta)">
        <div class="mb-16">
            <CompanyInformationSection :company="localCompany" />
            <SideFormSectionDivider />
            <CompanyDefaultBookingFormThemeSection :company="localCompany" />
            <SideFormSectionDivider />
            <CompanyInPersonHostDefinedMeetingLocationsSection
                :id="IN_PERSON_MEETING_LOCATIONS_SECTION_ID"
                :inPersonHostDefinedMeetingLocations="
                    localCompany.inPersonHostDefinedMeetingLocations
                "
            />
            <SideFormSectionDivider />
            <CompanyUsersSection
                :companyUserAggregates="localCompanyUserAggregates"
                :companyUserInvites="localCompanyUserInvites"
            />
            <SideFormSectionDivider />
            <SubscriptionForm
                :subscription="localSubscription"
                :plan="localPlan"
            />
            <SideFormSectionDivider />
            <DeleteCompanyForm />
        </div>

        <PageBottomPadding />
    </AppLayout>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import CompanyUsersSection from '@/App/Company/Component/CompanyUsersSection.vue'
    import CompanyUserAggregate from '@/App/CompanyUser/Entity/CompanyUserAggregate'
    import CompanyUserInvite from '@/App/CompanyUserInvite/Entity/CompanyUserInvite'
    import Subscription from '@/App/Subscription/Entity/Subscription'
    import Plan from '@/App/Plan/Entity/Plan'
    import AppLayout from '@/Shared/Layout/App/Sidebar/AppLayout.vue'
    import CompanyInformationSection from '@/App/Company/Component/CompanyInformationSection.vue'
    import Company from '@/App/Company/Entity/Company'
    import SubscriptionForm from '@/App/Company/Component/SubscriptionForm.vue'
    import DeleteCompanyForm from '@/App/Company/Component/DeleteCompanyForm.vue'
    import SideFormSectionDivider from '@/Shared/Component/SideFormSectionDivider.vue'
    import { IN_PERSON_MEETING_LOCATIONS_SECTION_ID } from '@/Shared/AutoGenerated/Types'
    import type {
        CompanyData,
        CompanyUserAggregateData,
        CompanyUserInviteData,
        PageMeta,
        PlanData,
        SubscriptionData,
    } from '@/Shared/AutoGenerated/Main'
    import AppSharedData from '@/Shared/Entity/AppSharedData'
    import PageBottomPadding from '@/Shared/Layout/App/Sidebar/PageBottomPadding.vue'
    import CompanyInPersonHostDefinedMeetingLocationsSection from '@/App/Company/Component/InPersonHostDefineMeetingLocation/CompanyInPersonHostDefinedMeetingLocationsSection.vue'
    import CompanyDefaultBookingFormThemeSection from '@/App/Company/Component/CompanyDefaultBookingFormThemeSection.vue'

    interface EditCompanyProps {
        pageMeta: PageMeta
        appSharedDataData: any
        companyData: CompanyData
        planData: PlanData
        subscriptionData: SubscriptionData
        companyUserAggregatesData: CompanyUserAggregateData[]
        companyUserInvitesData: CompanyUserInviteData[]
    }

    const props = defineProps<EditCompanyProps>()
    const appSharedData = AppSharedData.hydrate(props.appSharedDataData)
    const localSubscription = ref<Subscription>(
        Subscription.hydrateSingle(props.subscriptionData),
    )
    const localPlan = ref<Plan>(Plan.hydrateSingle(props.planData))
    const localCompany = ref<Company>(Company.hydrateSingle(props.companyData))
    const localCompanyUserAggregates = ref<CompanyUserAggregate[]>(
        CompanyUserAggregate.hydrateMultiple(props.companyUserAggregatesData),
    )
    const localCompanyUserInvites = ref<CompanyUserInvite[]>(
        CompanyUserInvite.hydrateMultiple(props.companyUserInvitesData),
    )
</script>
